export default "__VITE_ASSET__DcWcAhXz__"